<header class="header">
  <div class="container" *ngIf="config$ | async">
    <img id="site-logo" [src]="(config$ | async).siteLogoImg" alt="Logo" />
    <div class="header-title">
      <h1 class="section-title">{{(config$ | async).title}}</h1>
    </div>

  </div>
</header>

<router-outlet></router-outlet>